import type { SubmissionAssignment } from '../../../../../db/api/save-submission-assignment.js';

export const UNASSIGNED_BUCKET_ID = 'unassigned-bucket';

export interface ReviewSubmission {
  _id: string;
  studentId?: string;
  studentName?: string;
  imageIds?: string[];
  pages?: string[];
  taskSubmissions?: any[];
  /** Whether this submission's split is confirmed (locked for editing). */
  splitConfirmed?: boolean;
  splitEvaluationResult?: {
    confidence?: number;
    issues?: string[];
  };
}

export interface SubmissionReviewProps {
  submissions: ReviewSubmission[];
  /**
   * Master switch for split-confirmation locking. When true, confirmed submissions become
   * read-only individually and the canvas as a whole locks once every submission is confirmed.
   */
  lockingEnabled?: boolean;
  /** Saves the whole assignment (auto-save). Resolves to the ids of the created submissions, in entry order. */
  onSave: (assignment: SubmissionAssignment) => Promise<string[]>;
}

export interface OrderedPage {
  imageId: string;
  url: string;
  sourceSubmissionId: string;
}

export interface DragItem {
  bucketId: string;
  index: number;
}
